/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signingin1Inputs */

const en_signingin1 = /** @type {(inputs: Signingin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in...`)
};

const de_signingin1 = /** @type {(inputs: Signingin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden…`)
};

/**
* | output |
* | --- |
* | "Signing in..." |
*
* @param {Signingin1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signingin1 = /** @type {((inputs?: Signingin1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signingin1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signingin1(inputs)
	return de_signingin1(inputs)
});
export { signingin1 as "signingIn" }